import React from "react";

import { Slider, Courses, WhyChooseUs, Faq, HomeCta } from "../components";

const Home = () => {
  return (
    <>
      <Slider />
      <Courses />
      <WhyChooseUs />
      <Faq />
      <HomeCta />
    </>
  );
};

export default Home;
